// // //PRODUCCIÓN
export const DIPLOMADOS = 30;
export const POSGRADOS = 29;
export const CURSOS_LIBRES = 31;
export const ESTADOS_ID = 33;
export const PROCESOS = 34;
export const MATERIAS = 32;
export const PROGRAMAS = 5;
export const CURSOS_LIBRES_PRE = 46;
export const NOTAS = 47;
export const SEMI_DEPARTAMENTOS = 144;
export const SEMI_PROGRAMAS = 5;
export const SEMI_LINEA = 160;
export const SEMI_SUBLINEA = 161;
export const SEMI_GRUPOS_INVES = 162;
export const SEMI_AREAS_INVES = 163;
export const SEMI_ROLES = 164;
export const SOLICITUDES_INVESTIGACION = 194;
export const ESTADO_INVESTIGACION = 166;
export const SOLICITUDES_PAR_INVES = 167;
export const GESTION_TIPOS_INVESTIGACION = 168;
export const NUEVO_GESTION_TIPOS_INVESTIGACION =318;
export const MODALIDAD_PAR_INVESTIGACION = 171;
export const AMBITO_INVESTIGACION = 172;
export const CATEGORIA_INVESTIGACION = 173;
export const TIPOS_DE_PROD_BIBLIO_INVES = 174;
export const INDEXACION_INVESTIGACION = 175;
export const TIPO_DE_ARTICULO_INVESTIGACION = 176;
export const TIPO_DE_LIBRO_INVESTIGACION = 177;
export const TIPO_DE_CAPITULO_LIBRO_INVESTIGACION = 178;
export const TIPOS_DE_PROD_TEC_INVES = 179;
export const INPUTS_INVES_TIPO_TEC = 181;
export const TIPOS_DE_PATENTE_INVESTIGACION = 182;
export const DISEÑO_INDUSTRIAL_PROTOTIPO_TIENE = 183;
export const TIPOS_DE_PROTOTIPOS_INVESTIGACION = 184;
export const TIPOS_DE_SOFTWARE_INVESTIGACION = 185;
export const TIPO_SIGNO_DISTINTIVO_INVESTIGACION = 186;
export const TIPO_DE_EMPRESA_INVESTIGACION = 187;
export const TIPO_INNOVACION_EMP_INVESTIGACION = 188;
export const TIPO_ESPACIO_EVENTO_INVESTIGACION = 189;
export const TIPO_DISCIPLINA_AMBITO_INVESTIGACION = 190;
export const TIPO_AMBITO_INVESTIGACION = 191;
export const TIPO_ROL_INVESTIGACION = 192;
export const TIPO_EVENTO_INVESTIGACION = 193;
export const TIPO_INFORME_SEMILLEROS = 201;
export const TIPO_NORMA = 319;
export const PAISES = 195;
export const IDIOMAS = 169;
export const CIUDADES = 8;
export const DISCIPLINAS = 320;
export const TIPO_ESPACIO=321;
export const DISTNCION= 322;
export const DISPONIBILIDAD=323;
export const MECANISMO = 325;
export const VIA_SOLICITUDES=326;
export const REQUISITO_CURSOS = 253;
export const TIPO_CONTENIDODIGITAL = 327;
export const GENERO_LITERARIO = 328;
export const PUBLICO_OBJETIVO = 329;
export const RUTA_CIRCULACION = 330;
export const TIPO_DESARROLLO = 331;
export const COMPONENTE_DIGITAL = 332;
export const TIPO_CLASE = 333;
export const TIPO_TALLER_CREATIVO = 334;
export const TIPO_EVENTO_CIENTIFICO =335;
export const PRODUCTO_CIENTIFICO = 336;
export const TIPO_EVENTO_CIENTIFICO_TECNOLOGICA = 337;
export const TIPO_DISPONIBILIDAD_CIENTIFICA = 338;
export const TIPOS_DE_PROD_SOCIAL_CONOCIMIENTO =339;
export const LICENCIA= 340;
export const EMPRESA =341;
export const TIPOS_DE_PROD_RECURSO =342;
export const TIPOS_DE_PROD_ESTRATEGIAS =343;
export const TIPO_PROYECTO = 344;
export const ORIENTACION = 345;
export const VALORACION_TESIS = 346;
export const PROYECTO_ES =347;
export const TIPO_PROYECTO_TRABAJO= 348;
export const FINANCIACION=349;
export const TIPO_PROYECTO_ESTRAEGIAS=350;
export const TIPOS_VERSIONES_PRODUCCION=351;
export const DEPARTAMENTOSACADEMICOS=144;
export const TIPOS_DE_PROD_DIVULGACION =352;
export const INPUTSTEC =181;
export const SEMI_CENTROS_INVES = 361;


// test
// export const DIPLOMADOS = 30;
// export const POSGRADOS = 29;
// export const CURSOS_LIBRES = 31;
// export const ESTADOS_ID = 33;
// export const PROCESOS = 34;
// export const MATERIAS = 32;
// export const PROGRAMAS = 5;
// export const CURSOS_LIBRES_PRE = 46;
// export const NOTAS = 47;
// export const SEMI_DEPARTAMENTOS = 327;
// export const SEMI_PROGRAMAS = 5;
// export const SEMI_LINEA = 160;
// export const SEMI_SUBLINEA = 161;
// export const SEMI_GRUPOS_INVES = 162;
// export const SEMI_AREAS_INVES = 163;
// export const SEMI_ROLES = 164;
// export const SOLICITUDES_INVESTIGACION = 165;
// export const ESTADO_INVESTIGACION = 166;
// export const SOLICITUDES_PAR_INVES = 167;
// export const GESTION_TIPOS_INVESTIGACION = 168;
// export const NUEVO_GESTION_TIPOS_INVESTIGACION = 330;
// export const MODALIDAD_PAR_INVESTIGACION = 171;
// export const AMBITO_INVESTIGACION = 172;
// export const CATEGORIA_INVESTIGACION = 173;
// export const TIPOS_DE_PROD_BIBLIO_INVES = 174;
// export const INDEXACION_INVESTIGACION = 175;
// export const TIPO_DE_ARTICULO_INVESTIGACION = 176;
// export const TIPO_DE_LIBRO_INVESTIGACION = 177;
// export const TIPO_DE_CAPITULO_LIBRO_INVESTIGACION = 178;
// export const TIPOS_DE_PROD_TEC_INVES = 180;
// export const TIPOS_DE_PROD_DIVULGACION =331;
// export const INPUTS_INVES_TIPO_TEC = 181;
// export const TIPOS_DE_PATENTE_INVESTIGACION = 182;
// export const DISEÑO_INDUSTRIAL_PROTOTIPO_TIENE = 183;
// export const TIPOS_DE_PROTOTIPOS_INVESTIGACION = 184;
// export const TIPOS_DE_SOFTWARE_INVESTIGACION = 185;
// export const TIPO_SIGNO_DISTINTIVO_INVESTIGACION = 186;
// export const TIPO_DE_EMPRESA_INVESTIGACION = 187;
// export const TIPO_INNOVACION_EMP_INVESTIGACION = 188;
// export const TIPO_ESPACIO_EVENTO_INVESTIGACION = 189;
// export const TIPO_DISCIPLINA_AMBITO_INVESTIGACION = 190;
// export const TIPO_AMBITO_INVESTIGACION = 191;
// export const TIPO_ROL_INVESTIGACION = 192;
// export const TIPO_EVENTO_INVESTIGACION = 193;
// export const TIPO_INFORME_SEMILLEROS = 201;
// export const TIPO_NORMA = 332;
// export const PAISES = 195;
// export const CIUDADES = 8;
// export const DISCIPLINAS = 333;
// export const TIPO_ESPACIO=334;
// export const DISTNCION= 335;
// export const DISPONIBILIDAD=336;
// export const MECANISMO = 337;
// export const VIA_SOLICITUDES=338;
// export const IDIOMAS = 169;
// export const REQUISITO_CURSOS = 253;
// export const TIPO_CONTENIDODIGITAL = 339;
// export const GENERO_LITERARIO = 340;
// export const PUBLICO_OBJETIVO = 341;
// export const RUTA_CIRCULACION = 342;
// export const TIPO_DESARROLLO = 343;
// export const COMPONENTE_DIGITAL = 344;
// export const TIPO_CLASE = 345;
// export const TIPO_TALLER_CREATIVO = 346;
// export const TIPO_EVENTO_CIENTIFICO =347;
// export const PRODUCTO_CIENTIFICO = 348;
// export const TIPO_EVENTO_CIENTIFICO_TECNOLOGICA = 349;
// export const TIPO_DISPONIBILIDAD_CIENTIFICA = 350;
// export const TIPOS_DE_PROD_SOCIAL_CONOCIMIENTO =351;
// export const LICENCIA= 352;
// export const EMPRESA =353;
// export const TIPOS_DE_PROD_RECURSO =354;
// export const TIPOS_DE_PROD_ESTRATEGIAS =355;
// export const TIPO_PROYECTO = 356;
// export const ORIENTACION = 357;
// export const VALORACION_TESIS = 358;
// export const PROYECTO_ES =359;
// export const TIPO_PROYECTO_TRABAJO= 360;
// export const FINANCIACION=361;
// export const TIPO_PROYECTO_ESTRAEGIAS=362;
// export const TIPOS_VERSIONES_PRODUCCION=324;
// export const DEPARTAMENTOSACADEMICOS=2119;
// export const INPUTSTEC =181;
// export const SEMI_CENTROS_INVES = 353;


// // local
// export const DIPLOMADOS = 30;
// export const POSGRADOS = 29;
// export const CURSOS_LIBRES = 31;
// export const ESTADOS_ID = 33;
// export const PROCESOS = 34;
// export const MATERIAS = 32;
// export const PROGRAMAS = 5;
// export const CURSOS_LIBRES_PRE = 46;
// export const NOTAS = 47;
// export const SEMI_DEPARTAMENTOS = 117;
// export const SEMI_PROGRAMAS = 5;
// export const SEMI_LINEA = 119;
// export const SEMI_SUBLINEA = 120;
// export const SEMI_GRUPOS_INVES = 121;
// export const SEMI_AREAS_INVES = 122;
// export const SEMI_ROLES = 123;
// export const SOLICITUDES_INVESTIGACION = 153;
// export const ESTADO_INVESTIGACION = 125;
// export const SOLICITUDES_PAR_INVES = 126;
// export const GESTION_TIPOS_INVESTIGACION = 127;
// export const NUEVO_GESTION_TIPOS_INVESTIGACION = 4168;
// export const MODALIDAD_PAR_INVESTIGACION = 130;
// export const AMBITO_INVESTIGACION = 131;
// export const CATEGORIA_INVESTIGACION = 132;
// export const TIPOS_DE_PROD_BIBLIO_INVES = 133;
// export const INDEXACION_INVESTIGACION = 134;
// export const TIPO_DE_ARTICULO_INVESTIGACION = 135;
// export const TIPO_DE_LIBRO_INVESTIGACION = 136;
// export const TIPO_DE_CAPITULO_LIBRO_INVESTIGACION = 137;
// export const TIPOS_DE_PROD_TEC_INVES = 139;
// export const TIPOS_DE_PROD_DIVULGACION =4137;
// export const INPUTS_INVES_TIPO_TEC = 140;
// export const TIPOS_DE_PATENTE_INVESTIGACION = 141;
// export const DISEÑO_INDUSTRIAL_PROTOTIPO_TIENE = 142;
// export const TIPOS_DE_PROTOTIPOS_INVESTIGACION = 143;
// export const TIPOS_DE_SOFTWARE_INVESTIGACION = 144;
// export const TIPO_SIGNO_DISTINTIVO_INVESTIGACION = 145;
// export const TIPO_DE_EMPRESA_INVESTIGACION = 146;
// export const TIPO_INNOVACION_EMP_INVESTIGACION = 147;
// export const TIPO_ESPACIO_EVENTO_INVESTIGACION = 148;
// export const TIPO_DISCIPLINA_AMBITO_INVESTIGACION = 149;
// export const TIPO_AMBITO_INVESTIGACION = 150;
// export const TIPO_ROL_INVESTIGACION = 151;
// export const TIPO_EVENTO_INVESTIGACION = 152;
// export const TIPO_INFORME_SEMILLEROS = 2118;
// export const TIPO_NORMA = 4136;
// export const PAISES = 154;
// export const CIUDADES = 8;
// export const DISCIPLINAS = 4130;
// export const TIPO_ESPACIO=4131;
// export const DISTNCION= 4132;
// export const DISPONIBILIDAD=4135;
// export const MECANISMO = 4133;
// export const VIA_SOLICITUDES=4134;
// export const IDIOMAS = 128;
// export const REQUISITO_CURSOS = 4125;
// export const TIPO_CONTENIDODIGITAL = 4138;
// export const GENERO_LITERARIO = 4140;
// export const PUBLICO_OBJETIVO = 4141;
// export const RUTA_CIRCULACION = 4142;
// export const TIPO_DESARROLLO = 4143;
// export const COMPONENTE_DIGITAL = 4144;
// export const TIPO_CLASE = 4145;
// export const TIPO_TALLER_CREATIVO = 4146;
// export const TIPO_EVENTO_CIENTIFICO =4147;
// export const PRODUCTO_CIENTIFICO = 4148;
// export const TIPO_EVENTO_CIENTIFICO_TECNOLOGICA = 4149;
// export const TIPO_DISPONIBILIDAD_CIENTIFICA = 4150;
// export const TIPOS_DE_PROD_SOCIAL_CONOCIMIENTO =4151;
// export const LICENCIA= 4153;
// export const EMPRESA =4154;
// export const TIPOS_DE_PROD_RECURSO =4155;
// export const TIPOS_DE_PROD_ESTRATEGIAS =4156;
// export const TIPO_PROYECTO = 4158;
// export const ORIENTACION = 4159;
// export const VALORACION_TESIS = 4160;
// export const PROYECTO_ES =4161;
// export const TIPO_PROYECTO_TRABAJO= 4162;
// export const FINANCIACION=4163;
// export const TIPO_PROYECTO_ESTRAEGIAS=4166;
// export const TIPOS_VERSIONES_PRODUCCION=4167;
// export const DEPARTAMENTOSACADEMICOS=2119;
// export const INPUTSTEC =181;
// export const SEMI_CENTROS_INVES = 4170;
